import {Component, Input, OnChanges, OnInit} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})

export class VideoComponent implements OnInit, OnChanges {

  @Input() videoUrl!: string;
  @Input() contentAlign: string = 'CENTER';
  @Input() fit: 'fill-screen' | 'aspect-ratio' = 'fill-screen';
  supportedFormatsInternal: any[] = [{ type: '.mp4', extension: 'video/mp4' },
  { type: '.m4p', extension: 'video/mp4' },
  { type: '.m4v', extension: 'video/mp4' },
  { type: '.webm', extension: 'video/webm' },
  { type: '.ogg', extension: 'video/ogg' },
  { type: '.ogv', extension: 'video/ogg' },
  { type: '.3gp', extension: 'video/3gp' }];
  internalVideo: boolean = false;
  supportedFormatsExternal: any[] = [{ type: 'youtube', matchString: 'www.youtube.com/embed' }];
  supportedVideo: boolean = false;
  safeUrl: any;
  extension: string = '';

  constructor(private sanitize: DomSanitizer) { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.videoUrl || this.contentAlign) {
      this.supportedFormatsInternal.forEach(ele => {
        if (this.videoUrl.indexOf(ele.type) > -1) {
          this.internalVideo = true;
          this.supportedVideo = true;
          this.extension = ele.extension;
          return;
        }
      });

      if (!this.internalVideo && !this.supportedVideo) {
        this.supportedFormatsExternal.forEach(ele => {
          if (this.videoUrl.indexOf(ele.matchString) > -1) {
            this.internalVideo = false;
            this.supportedVideo = true;
            if (this.contentAlign === 'CENTER') {
              const url = new URL(this.videoUrl);
              url.searchParams.set('autoplay', '1');
              url.searchParams.set('mute', '1');
              url.searchParams.set('loop', '1');
              this.videoUrl = url.href;
            }
          }
        });
        this.safeUrl = this.sanitize.bypassSecurityTrustResourceUrl(this.videoUrl);
      }
    }
  }

}
